/**
 * 지금 사용자가 글을 쓰는 중인지 전역으로 추적한다.
 *
 * 스와이프 뒤로가기(useSwipeBack)는 화면 어디서 시작하든 오른쪽으로 밀면 발동한다.
 * 그래서 댓글을 쓰다가 다른 댓글의 글자를 길게 눌러 복사하려고 핸들을 옆으로 끌면,
 * 그 손짓이 뒤로가기로 잡혀 쓰던 내용이 통째로 사라졌다.
 *
 * 선택 영역을 감지해 걸러보려 했지만, 네이티브 선택 핸들을 끄는 동안 페이지가 보는
 * 값이 기대와 달라 확실하지 않았다. 반면 "지금 글을 쓰는 중인가"는 화면이 확실히
 * 아는 사실이다. 쓰는 중에는 제스처를 아예 재우는 편이 안전하다.
 *
 * 뒤로가려면 상단 뒤로가기 버튼을 쓰면 된다. 쓰던 글이 날아가는 것보다 낫다.
 */

let composingCount = 0

/**
 * 글쓰기 시작 시 호출. 반환된 해제 함수를 끝날 때 호출한다(1회만 적용).
 *
 * 입력칸이 여러 개일 수 있어 개수로 센다. 하나라도 열려 있으면 쓰는 중이다.
 */
export function registerComposing(): () => void {
  composingCount += 1
  let released = false

  return () => {
    if (released) return
    released = true
    composingCount = Math.max(0, composingCount - 1)
  }
}

/** 지금 글을 쓰는 중인지 */
export function isComposing(): boolean {
  return composingCount > 0
}
